import ClassificationCard from "./classification-card";

export default ClassificationCard;